import React, { Component } from "react";
import { observer, inject } from "mobx-react";

import { Select, MenuItem, Grid, IconButton } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import moment from "moment";

import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";
import EventIcon from "@material-ui/icons/Event";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

import "./StaffFilter.css";
import SelectFieldVenueFilter from "../fields/SelectFieldVenueFilter";
import BookingCalendarFilter from "../booking/bookingCalendarFilter";
import { ProfileType } from "../../types/enum";

const dateFormat = "DD-MM-YYYY";
const monthFormat = "MMM YYYY";

@inject("profileStore", "venueStore", "staffFilterStore", "venueActStore", "bookingRequestStore")
@observer
class StaffFilter extends Component {
    postChangeInterval = undefined;

    constructor(props) {
        super(props);
        this.state = {
            dashboardFilter: "monthly",
            showDateRangePicker: false,
            startDate: moment().startOf("month"),
            endDate: moment().endOf("month"),
            organisations: [],
            states: [],
            regions: [],
            venues: [],
            acts: [],
            level1Label: "Organisation",
            level2Label: "State",
            level3Label: "Region",
            allVenues: [],
            allRegions: [],
            allStates: []
        };
    }

    componentDidMount() {
        this.props.staffFilterStore.resetFilterData();
        Promise.all([
            this.props.venueActStore.getStaffActRosterMyGigs(null, true),
            this.props.venueStore.getUserVenuesBasedOnPermissionSimple()
        ]).then( response => {
            let actRoster = response[0];
            let venues = response[1];
            if(actRoster){
                this.mapActToSuggestions(actRoster);
            }
            if (venues) {
                this.mapVenuesToSuggestions(venues);
            }
        })
    }
   
    mapBookingCreator = () => {
        let { bookingCreators } = this.props.bookingRequestStore;
        let creators = [{
            value: 0,
            label: "All Booking Creators"
        }];
        bookingCreators.forEach(bookingCreator => {
            creators.push({
                value: bookingCreator.id,
                label:  bookingCreator ? (bookingCreator?.firstName + " " +bookingCreator?.lastName) : ""
            })
        })

        return creators;
    }
    mapActToSuggestions = actRosters => {
        let acts = [];

        actRosters.forEach(actRoster => {
            if(!acts.find(x => x.id === actRoster.actId)){
                acts.push(actRoster.act);
            }
        });

        acts.sort((a, b) => (a.actName < b.actName ? -1 : 1))

        this.setState({
            ...this.state,
            acts: acts
        })
    }

    mapVenuesToSuggestions = venues => {
        var organisations = [];
        var states = [];
        var regions = [];
        var level1Label = "Organisation";
        var level2Label = "State";
        var level3Label = "Region";

        venues.forEach(venue => {
            if (!organisations.find(x => x.id === venue.organisationId)) {
                if (!_.isEmpty(venue.organisation) && venue.organisation) {
                    organisations.push(venue.organisation);
                }
            }
            if (!states.find(x => x.id === venue.stateId)) {
                if (!_.isEmpty(venue.stateEntity) && venue.stateEntity) {
                    states.push(venue.stateEntity);
                }
            }
            if (!regions.find(x => x.id === venue.regionId)) {
                if (!_.isEmpty(venue.region) && venue.region) {
                    regions.push(venue.region);
                }
            }
        });

        if (organisations.length > 0) {
            level1Label = organisations[0].level1Label;
            level2Label = organisations[0].level2Label;
            level3Label = organisations[0].level3Label;
        }

        this.setState({
            ...this.state,
            organisations,
            states,
            regions,
            venues,
            level1Label,
            level2Label,
            level3Label,
            allVenues: venues,
            allStates: states,
            allRegions: regions
            // organisationFilter: organisations.length === 1 ? organisations[0].id : this.state.organisationFilter,
            // stateFilter: states.length === 1 ? states[0].id : this.state.stateFilter,
            // regionFilter: regions.length === 1 ? regions[0].id : this.state.regionFilter,
            // venueFilter: venues.length === 1 ? venues[0].id : this.state.venueFilter
        });
    };

    postFilterChange = () => {
        const { organisationFilter, stateFilter, regionFilter, venueFilter, startDate, endDate, actFilter, creatorId, dayOfWeekFilter } = this.props.staffFilterStore;
        var filterData = {
            organisation: organisationFilter,
            state: stateFilter,
            region: regionFilter,
            venue: venueFilter,
            startDate: startDate,
            endDate: endDate,
            act: actFilter,
            creatorId: creatorId,
            dayOfWeek: dayOfWeekFilter
        };

        let currentState = this.state;
        if (organisationFilter) {
            currentState.venues = currentState.allVenues.filter(v => v.organisationId === organisationFilter);
        } else if (stateFilter) {
            currentState.regions = currentState.allRegions.filter(r => r.stateId === stateFilter);
        } else if (regionFilter) {
            currentState.venues = currentState.allVenues.filter(v => v.regionId === regionFilter);
        }

        this.setState(currentState)

        if (this.postChangeInterval) {
            clearInterval(this.postChangeInterval);
        }

        this.postChangeInterval = setInterval(() => {
            this.props.postChangeEvent(filterData);
            clearInterval(this.postChangeInterval);
        }, 1000);
    };

    onChange = e => {
        this.props.staffFilterStore.setFilterType(e.target.value);
        this.triggerFilterChangeImmediate();
    };

    onChangeAct = value => {
        this.props.staffFilterStore.setActFilter(value);
        this.triggerFilterChangeImmediate();
    }

    handleDayOfWeekChange = (e) => {
        const value = e.target.value === "" ? null : Number(e.target.value);
        this.props.staffFilterStore.setDayOfWeekFilter(value);
        this.triggerFilterChangeImmediate();
    };

    onChangeCreators = value => {
        this.props.staffFilterStore.setCreatorFilter(value);
        this.triggerFilterChangeImmediate();
    }
    
    onOrganisationChange = e => {
        const { organisations } = this.state;
        let organisation = organisations.find(x => x.id === e.target.value);

        this.props.staffFilterStore.setOrganisationFilter(e.target.value);
        this.props.staffFilterStore.setStateFilter(0);
        this.props.staffFilterStore.setRegionFilter(0);
        this.props.staffFilterStore.setVenueFilter(0);

        this.setState(
            {
                level1Label: organisation ? organisation.level1Label : "Organisation",
                level2Label: organisation ? organisation.level2Label : "State",
                level3Label: organisation ? organisation.level3Label : "Region"
            },
            () => {
                this.triggerFilterChangeImmediate();
            }
        );
    };

    onStateChange = e => {
        this.props.staffFilterStore.setStateFilter(e.target.value);
        this.props.staffFilterStore.setRegionFilter(0);
        this.props.staffFilterStore.setVenueFilter(0);
        this.triggerFilterChangeImmediate();
    };

    onRegionChange = e => {
        this.props.staffFilterStore.setRegionFilter(e.target.value);
        this.props.staffFilterStore.setVenueFilter(0);
        this.triggerFilterChangeImmediate();
    };

    onVenueChange = value => {
        this.props.staffFilterStore.setVenueFilter(value);
        this.triggerFilterChangeImmediate();
    };

    onChangeStartDate = value => {
        const { endDate } = this.props.staffFilterStore;
        this.props.staffFilterStore.setStartDate(value);
        if (moment(value).endOf("day") > moment(endDate).endOf("day")) {
            this.props.staffFilterStore.setEndDate(value);
        }

        this.triggerFilterChangeImmediate();
    };

    onChangeEndDate = value => {
        const { startDate } = this.props.staffFilterStore;
        this.props.staffFilterStore.setEndDate(value);
        if (moment(value).endOf("day") < moment(startDate).endOf("day")) {
            this.props.staffFilterStore.setStartDate(value);
        }
        this.triggerFilterChangeImmediate();
    };

    onChangeMonth = value => {
        const startDate = moment(value).date(1);
        this.props.staffFilterStore.setStartDate(startDate);

        const endDate = moment(value).date(moment(value).daysInMonth());
        this.props.staffFilterStore.setEndDate(endDate);

        this.triggerFilterChangeImmediate();
    };

    onPrevMonth = () => {
        const { startDate } = this.props.staffFilterStore;
        const prevMonth = moment(startDate).subtract(1, 'month');
        this.onChangeMonth(prevMonth);
    };

    onNextMonth = () => {
        const { startDate } = this.props.staffFilterStore;
        const nextMonth = moment(startDate).add(1, 'month');
        this.onChangeMonth(nextMonth);
    };

    triggerFilterChangeImmediate = () => {
        const { 
            filterType, 
            organisationFilter, 
            stateFilter, 
            regionFilter, 
            venueFilter, 
            startDate, 
            endDate, 
            actFilter, 
            creatorFilter,
            dayOfWeekFilter 
        } = this.props.staffFilterStore;
        var filterData = {
            filterType: filterType,
            organisation: organisationFilter,
            state: stateFilter,
            region: regionFilter,
            venue: venueFilter,
            startDate: startDate,
            endDate: endDate,
            act: actFilter,
            creatorId: creatorFilter,
            dayOfWeek: dayOfWeekFilter
        };
        if (this.postChangeInterval) {
            clearInterval(this.postChangeInterval);
        }
        this.props.postChangeEvent(filterData);
    };

    isAustralianCalendar = () => {
        const { currentProfile } = this.props.profileStore;
        if (currentProfile?.type === ProfileType.Staff.ordinal) {
            if (currentProfile.hasOrganisation) {
                return currentProfile.organisation?.[0]?.currency === "AUD";
            }
            return currentProfile.venue?.currency === "AUD";
        }
        return currentProfile?.currency === "AUD";
    };

    getAustralianFYQuarterDates = (fyYear, quarter) => {
        let startDate, endDate;
        switch (quarter) {
            case 1:
                startDate = moment().year(fyYear - 1).month(6).date(1).startOf("day");
                endDate = moment().year(fyYear - 1).month(8).endOf("month");
                break;
            case 2:
                startDate = moment().year(fyYear - 1).month(9).date(1).startOf("day");
                endDate = moment().year(fyYear - 1).month(11).endOf("month");
                break;
            case 3:
                startDate = moment().year(fyYear).month(0).date(1).startOf("day");
                endDate = moment().year(fyYear).month(2).endOf("month");
                break;
            case 4:
                startDate = moment().year(fyYear).month(3).date(1).startOf("day");
                endDate = moment().year(fyYear).month(5).endOf("month");
                break;
            default:
                startDate = moment();
                endDate = moment();
        }
        return { startDate, endDate };
    };

    getCurrentAustralianFY = () => {
        const now = moment();
        const month = now.month();
        if (month >= 6) {
            return now.year() + 1;
        }
        return now.year();
    };

    getCurrentAustralianFYQuarter = () => {
        const now = moment();
        const month = now.month();
        if (month >= 6 && month <= 8) return 1;
        if (month >= 9 && month <= 11) return 2;
        if (month >= 0 && month <= 2) return 3;
        return 4;
    };

    onChangeQuarter = value => {
        if (!value) return;
        
        if (this.isAustralianCalendar()) {
            const [fyPart, quarterPart] = value.split("-Q");
            const fyYear = parseInt(fyPart.replace("FY", ""));
            const quarter = parseInt(quarterPart);
            const { startDate, endDate } = this.getAustralianFYQuarterDates(fyYear, quarter);
            this.props.staffFilterStore.setStartDate(startDate);
            this.props.staffFilterStore.setEndDate(endDate);
        } else {
            const [year, quarter] = value.split("-Q");
            const startDate = moment().year(parseInt(year)).quarter(parseInt(quarter)).startOf("quarter");
            this.props.staffFilterStore.setStartDate(startDate);
            const endDate = moment().year(parseInt(year)).quarter(parseInt(quarter)).endOf("quarter");
            this.props.staffFilterStore.setEndDate(endDate);
        }
        
        this.postFilterChange();
    };

    mapQuarterSuggestions = () => {
        const suggestions = [];
        
        if (this.isAustralianCalendar()) {
            const currentFY = this.getCurrentAustralianFY();
            for (let fy = currentFY; fy >= currentFY - 2; fy--) {
                for (let q = 4; q >= 1; q--) {
                    suggestions.push({
                        value: `FY${fy}-Q${q}`,
                        label: `Q${q} FY${fy}`
                    });
                }
            }
        } else {
            const currentYear = moment().year();
            for (let year = currentYear; year >= currentYear - 2; year--) {
                for (let q = 4; q >= 1; q--) {
                    suggestions.push({
                        value: `${year}-Q${q}`,
                        label: `Q${q} ${year}`
                    });
                }
            }
        }
        return suggestions;
    };

    getSelectedQuarterValue = () => {
        const { startDate } = this.props.staffFilterStore;
        
        if (this.isAustralianCalendar()) {
            if (startDate) {
                const m = moment(startDate);
                const month = m.month();
                let fy, quarter;
                if (month >= 6 && month <= 8) {
                    fy = m.year() + 1;
                    quarter = 1;
                } else if (month >= 9 && month <= 11) {
                    fy = m.year() + 1;
                    quarter = 2;
                } else if (month >= 0 && month <= 2) {
                    fy = m.year();
                    quarter = 3;
                } else {
                    fy = m.year();
                    quarter = 4;
                }
                return `FY${fy}-Q${quarter}`;
            }
            return `FY${this.getCurrentAustralianFY()}-Q${this.getCurrentAustralianFYQuarter()}`;
        }
        
        if (startDate) {
            const m = moment(startDate);
            return `${m.year()}-Q${m.quarter()}`;
        }
        return `${moment().year()}-Q${moment().quarter()}`;
    };

    getFilteredStates = () => {
        const { states, organisationFilter } = this.state;
        var filteredStates = [...states];
        if (organisationFilter && organisationFilter !== 0) {
            filteredStates = states.filter(x => x.organisationId === organisationFilter);
        }

        if (filteredStates.length === 1) {
            const firstState = filteredStates[0];
            if (this.state.stateFilter !== firstState.id) {
                this.setState({
                    ...this.state,
                    stateFilter: firstState.id
                });
            }
        }
        return filteredStates;
    };

    getFilteredRegion = () => {
        const { regions, stateFilter, organisationFilter } = this.state;

        var filteredStates = this.getFilteredStates();

        var filteredRegion = [...regions];

        if (stateFilter && stateFilter !== 0) {
            filteredRegion = regions.filter(x => x.stateId === stateFilter);
        }

        if (organisationFilter) {
            filteredRegion = regions.filter(x => filteredStates.find(y => y.id === x.stateId));
        }

        if (filteredRegion.length === 1) {
            const firstRegion = filteredRegion[0];
            if (this.state.regionFilter !== firstRegion.id) {
                this.setState({
                    ...this.state,
                    regionFilter: firstRegion.id
                });
            }
        }

        return filteredRegion;
    };

    getFilteredVenues = () => {
        const { venues, organisationFilter, stateFilter, regionFilter } = this.state;
        var filteredVenues = [...venues];

        if (organisationFilter && organisationFilter !== 0) {
            filteredVenues = filteredVenues.filter(x => x.organisationId === organisationFilter);
        }

        if (stateFilter && stateFilter !== 0) {
            filteredVenues = filteredVenues.filter(x => x.stateId === stateFilter);
        }

        if (regionFilter && regionFilter !== 0) {
            filteredVenues = filteredVenues.filter(x => x.regionId === regionFilter);
        }
        if (filteredVenues.length === 1) {
            const firstVenue = filteredVenues[0];
            if (this.state.venueFilter !== firstVenue.id) {
                this.setState({
                    ...this.state,
                    venueFilter: firstVenue.id
                });
            }
        }

        return filteredVenues;
    };

    mapActSuggestions = () => {
        const { acts } = this.state;
        let suggestions = [{
            value: 0,
            label: "All Acts"
        }];

        acts.forEach(act => {
            suggestions.push({
                value: act.id,
                label: act.actName
            })
        })

        return suggestions;
    }

    mapVenueSuggestions = () => {
        let suggestions = [{
            value: 0,
            label: "All Venues"
        }];

        this.getFilteredVenues().forEach(venue => {
            suggestions.push({
                value: venue.id,
                label: venue.profileName
            })
        })

        return suggestions;
    }

   

    render() {
        const { organisations, states, regions, venues, level1Label, level2Label, level3Label } = this.state;
        const { showActFilter,isSocialPost } = this.props;
        const { filterType, startDate, endDate, organisationFilter, stateFilter, regionFilter, venueFilter, actFilter, creatorId, dayOfWeekFilter } = this.props.staffFilterStore;

        
        return (
            <Grid container spacing={8} alignItems="center" justify="flex-end">
                <Grid item>
                    <Select
                        className="dark-select slim-input"
                        fullWidth
                        value={dayOfWeekFilter !== null ? dayOfWeekFilter : ""}
                        onChange={this.handleDayOfWeekChange}
                        displayEmpty
                        classes={{
                            root: "text-white",
                            icon: "text-white"
                        }}
                    >
                        <MenuItem value="">All Days</MenuItem>
                        <MenuItem value={1}>Monday</MenuItem>
                        <MenuItem value={2}>Tuesday</MenuItem>
                        <MenuItem value={3}>Wednesday</MenuItem>
                        <MenuItem value={4}>Thursday</MenuItem>
                        <MenuItem value={5}>Friday</MenuItem>
                        <MenuItem value={6}>Saturday</MenuItem>
                        <MenuItem value={0}>Sunday</MenuItem>
                    </Select>
                </Grid>
                  {
                  showActFilter ? (<Grid item>
                        <SelectFieldVenueFilter 
                            suggestions={this.mapBookingCreator()}
                            onChange={this.onChangeCreators}
                            value={creatorId}
                            placeholder="Select booking creator"
                            color='#A9A9A9'
                            classes={{
                                root: "pull-right dark-select slim-input",
                                icon: "text-white",
                                input: "text-primary"
                            }}
                        />
                    </Grid>) : null
                }
                {
                  showActFilter ? (
                    <Grid item>
                        <SelectFieldVenueFilter 
                            suggestions={this.mapActSuggestions()}
                            onChange={this.onChangeAct}
                            value={actFilter}
                            placeholder="Select Act"
                            paginated={this.props.paginatedActFilter}
                            pageSize={20}
                            color='#A9A9A9'
                            classes={{
                                root: "pull-right dark-select slim-input",
                                icon: "text-white",
                                input: "text-primary"
                            }}
                        />
                    </Grid>
                  ) : null
                }
                {organisations && !showActFilter &&
                    organisations.length > 0 && (
                        <Grid item>
                            <Select
                                label="Organisation"
                                className="pull-right dark-select slim-input"
                                fullWidth
                                value={organisationFilter}
                                onChange={this.onOrganisationChange}
                                inputProps={{
                                    color: "primary"
                                }}
                                classes={{
                                    root: "text-white",
                                    icon: "text-white"
                                }}
                            >
                                <MenuItem value={0}>All {`${level1Label}s` || "Organisations"}</MenuItem>
                                {organisations.map(organisation => (
                                    <MenuItem key={organisation.id} value={organisation.id}>
                                        {organisation.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    )}
                {states && !showActFilter &&
                    states.length > 0 && (
                        <Grid item>
                            <Select
                                label="State"
                                className="pull-right dark-select slim-input"
                                fullWidth
                                value={stateFilter}
                                onChange={this.onStateChange}
                                inputProps={{
                                    color: "primary"
                                }}
                                classes={{
                                    root: "text-white",
                                    icon: "text-white"
                                }}
                            >
                                <MenuItem value={0}>All {`${level2Label}s` || "States"}</MenuItem>
                                {this.getFilteredStates().map(state => (
                                    <MenuItem key={state.id} value={state.id}>
                                        {state.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    )}
                {regions && !showActFilter &&
                    regions.length > 0 && (
                        <Grid item>
                            <Select
                                label="Region"
                                className="pull-right dark-select slim-input"
                                fullWidth
                                value={regionFilter}
                                onChange={this.onRegionChange}
                                inputProps={{
                                    color: "primary"
                                }}
                                classes={{
                                    root: "text-white",
                                    icon: "text-white"
                                }}
                            >
                                <MenuItem value={0}>All {`${level3Label}s` || "Regions"}</MenuItem>
                                {this.getFilteredRegion().map(region => (
                                    <MenuItem key={region.id} value={region.id}>
                                        {region.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    )}
                {!this.props.hideVenueFilter && venues &&
                    venues.length > 0 && (
                        <Grid item>
                            <SelectFieldVenueFilter
                                suggestions={this.mapVenueSuggestions()}
                                onChange={this.onVenueChange}
                                value={venueFilter}
                                placeholder="Select Venue"
                                paginated={this.props.paginatedVenueFilter}
                                pageSize={20}
                                color='#A9A9A9'
                                classes={{
                                    root: "pull-right dark-select slim-input",
                                    icon: "text-white",
                                    input: "text-primary"
                                }}
                            />
                        </Grid>
                    )}
                <Grid item>
                    <Select
                        label="Filter"
                        className="dark-select slim-input"
                        fullWidth
                        value={filterType}
                        onChange={this.onChange}
                        inputProps={{
                            color: "primary"
                        }}
                        classes={{
                            root: "text-white",
                            icon: "text-white"
                        }}
                    >
                        {/* {this.props.hideAllTime ? null : <MenuItem value="all">All-Time</MenuItem>}  */}
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="week">This Week</MenuItem>
                        <MenuItem value="lastweek">Last Week</MenuItem>
                        {/* <MenuItem value="month">This Month</MenuItem>
                        <MenuItem value="nextMonth">Next Month</MenuItem> */}
                        <MenuItem value="monthly">Month</MenuItem>
                        <MenuItem value="quarterly">Quarter</MenuItem>
                        <MenuItem value="custom">Custom</MenuItem>
                    </Select>
                </Grid>
                {filterType === "custom" && (
                    <Grid item>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                emptyLabel="From"
                                margin="none"
                                className="dark-datepicker slim-input"
                                value={startDate}
                                onChange={this.onChangeStartDate}
                                keyboardIcon={<EventIcon />}
                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                rightArrowIcon={<KeyboardArrowRightIcon />}
                                format={dateFormat}
                                InputProps={{
                                    classes: {
                                        root: "text-white"
                                    }
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                )}
                {filterType === "custom" && (
                    <Grid item className="filterHalf">
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                emptyLabel="to"
                                margin="none"
                                className="dark-datepicker slim-input"
                                value={endDate}
                                onChange={this.onChangeEndDate}
                                format={dateFormat}
                                keyboardIcon={<EventIcon />}
                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                rightArrowIcon={<KeyboardArrowRightIcon />}
                                InputProps={{
                                    classes: {
                                        root: "text-white"
                                    }
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                )}
                {filterType === "monthly" && (
                    <Grid item className="filterFull">
                        <div className="month-picker-with-nav">
                            <IconButton 
                                size="small" 
                                onClick={this.onPrevMonth}
                                className="month-nav-button"
                            >
                                <KeyboardArrowLeftIcon />
                            </IconButton>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    views={["year", "month"]}
                                    emptyLabel="..."
                                    margin="none"
                                    className="dark-datepicker slim-month-input"
                                    value={startDate}
                                    onChange={this.onChangeMonth}
                                    format={monthFormat}
                                    keyboardIcon={<EventIcon />}
                                    leftArrowIcon={<KeyboardArrowLeftIcon />}
                                    rightArrowIcon={<KeyboardArrowRightIcon />}
                                    fullWidth
                                    autoOk
                                    InputProps={{
                                        classes: {
                                            root: "text-white pull-right"
                                        }
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                            <IconButton 
                                size="small" 
                                onClick={this.onNextMonth}
                                className="month-nav-button"
                            >
                                <KeyboardArrowRightIcon />
                            </IconButton>
                        </div>
                    </Grid>
                )}
                {filterType === "quarterly" && (
                    <Grid item className="filterFull">
                        <BookingCalendarFilter
                            id="quarterFilter"
                            suggestions={this.mapQuarterSuggestions()}
                            onChange={this.onChangeQuarter}
                            value={this.getSelectedQuarterValue()}
                            placeholder="Select Quarter"
                            fullWidth
                        />
                    </Grid>
                )}
            </Grid>
        );
    }
}

export default StaffFilter;
